<div class="suche">

  <!-- ========================================================
       Hero Search (Variante B inspiriert)
  ======================================================== -->
  <section class="suche__hero">
    <div class="suche__hero-inner">

      <div class="suche__hero-text">
        <span class="suche__eyebrow">
          @if (selectedGewerk) {
            {{ getGewerkLabel(selectedGewerk) }} · {{ ortInput || 'Deutschland' }}
          } @else {
            Handwerker · {{ ortInput || 'Deutschland' }}
          }
        </span>
        <h1 class="suche__headline">
          Was soll heute<br>
          <em>gemacht werden?</em>
        </h1>
      </div>

      <!-- Segmented search bar -->
      <form class="suche__search-bar" (ngSubmit)="onSuche()">

        <!-- Gewerk -->
        <div class="suche__search-field">
          <label class="suche__search-label">Gewerk</label>
          <input
            type="text"
            [(ngModel)]="gewerkInput"
            name="gewerkInput"
            placeholder="Alle Gewerke"
            class="suche__search-input"
            (input)="onGewerkInput()"
            (focus)="onGewerkFocus()"
            (blur)="onGewerkBlur()"
            autocomplete="off"
            aria-label="Gewerk"
          />
          @if (gewerkDropdownOpen) {
            <ul class="suche__autocomplete" role="listbox">
              <li
                class="suche__autocomplete-item"
                (mousedown)="selectGewerkOption(null)"
                role="option"
              >
                <i class="pi pi-th-large" aria-hidden="true"></i>
                Alle Gewerke
              </li>
              @for (g of filteredGewerke; track g.id) {
                <li
                  class="suche__autocomplete-item"
                  (mousedown)="selectGewerkOption(g)"
                  role="option"
                >
                  <i [class]="'pi ' + g.icon" aria-hidden="true"></i>
                  {{ g.label }}
                </li>
              }
            </ul>
          }
        </div>

        <div class="suche__search-sep" aria-hidden="true"></div>

        <!-- Ort -->
        <div class="suche__search-field">
          <label class="suche__search-label">Ort</label>
          <input
            type="text"
            [(ngModel)]="ortInput"
            name="ortInput"
            placeholder="Düsseldorf, 40213…"
            class="suche__search-input"
            (input)="onOrtInput()"
            (focus)="onOrtFocus()"
            (blur)="onOrtBlur()"
            autocomplete="off"
            aria-label="Ort"
          />
          @if (ortDropdownOpen && ortSuggestions.length > 0) {
            <ul class="suche__autocomplete" role="listbox">
              @for (s of ortSuggestions; track s.mapboxId) {
                <li
                  class="suche__autocomplete-item"
                  (mousedown)="selectOrt(s)"
                  role="option"
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s7-7 7-12a7 7 0 0 0-14 0c0 5 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/></svg>
                  <span>
                    <strong>{{ s.name }}</strong>
                    @if (s.placeFormatted && s.placeFormatted !== s.name) {
                      <span class="suche__autocomplete-sub"> · {{ s.placeFormatted }}</span>
                    }
                  </span>
                </li>
              }
            </ul>
          }
        </div>

        <button type="submit" class="suche__search-submit">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
          Suchen
        </button>
      </form>

    </div>
  </section>

  <!-- ========================================================
       Gewerk-Chips + View toggle
  ======================================================== -->
  <div class="suche__filters">
    <div class="suche__filters-inner">
      <div class="suche__chips">
        <button
          class="suche__chip"
          [class.suche__chip--active]="!selectedGewerk"
          (click)="onChipAll()"
          type="button"
        >Alle</button>
        @for (g of gewerke; track g.id) {
          <button
            class="suche__chip"
            [class.suche__chip--active]="selectedGewerk === g.id"
            (click)="onChipSelect(g)"
            type="button"
          >{{ g.label }}</button>
        }
      </div>

      <div class="suche__view-toggle">
        <button
          class="suche__view-btn"
          [class.suche__view-btn--active]="view === 'list'"
          (click)="view = 'list'"
          type="button"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>
          Liste
        </button>
        <button
          class="suche__view-btn"
          [class.suche__view-btn--active]="view === 'map'"
          (click)="view = 'map'"
          type="button"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M9 3 3 5v16l6-2 6 2 6-2V3l-6 2-6-2Z"/><path d="M9 3v16M15 5v16"/></svg>
          Karte
        </button>
      </div>
    </div>
  </div>

  @if (geocodeError) {
    <div class="suche__notice">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 9v4M12 17h.01M10.3 3.7 2 20h20L13.7 3.7a2 2 0 0 0-3.4 0Z"/></svg>
      Ort konnte nicht gefunden werden — zeige alle Ergebnisse.
    </div>
  }

  <!-- ========================================================
       Results
  ======================================================== -->
  <div class="suche__body">

    @if (loading) {
      <div class="suche__results-meta">
        <div class="suche__skeleton-line"></div>
      </div>
      <div class="suche__list">
        @for (_ of skeletonItems; track $index) {
          <div class="suche__skeleton-card">
            <div class="suche__skeleton-img"></div>
            <div class="suche__skeleton-body">
              <div class="suche__skeleton-line suche__skeleton-line--wide"></div>
              <div class="suche__skeleton-line"></div>
              <div class="suche__skeleton-line suche__skeleton-line--narrow"></div>
            </div>
          </div>
        }
      </div>
    }

    @if (!loading && result) {
      @if (result.total === 0) {
        <div class="suche__empty">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--cr-stone-400)" stroke-width="1.5" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
          <p>
            @if (selectedGewerk) {
              Keine Handwerker für „{{ getGewerkLabel(selectedGewerk) }}" gefunden.
            } @else {
              Noch keine Handwerker eingetragen.
            }
          </p>
          @if (selectedGewerk) {
            <button class="suche__empty-link" type="button" (click)="onChipAll()">Alle Gewerke ansehen</button>
          }
        </div>
      } @else {
        <div class="suche__results-meta">
          <span>
            <strong>{{ result.total }}</strong>
            {{ result.total === 1 ? 'Betrieb' : 'Betriebe' }}
            @if (selectedGewerk) { · {{ getGewerkLabel(selectedGewerk) }} }
            @if (ortInput.trim()) { · {{ ortInput.trim() }} }
          </span>
          <select class="suche__sort" aria-label="Sortierung">
            <option>Am nächsten</option>
            <option>Beste Bewertung</option>
            <option>Günstigster Preis</option>
          </select>
        </div>

        <ul class="suche__list" role="list">
          @for (h of result.items; track h.id) {
            <li><app-handwerker-karte [handwerker]="h" /></li>
          }
        </ul>

        @if (result.total > result.proSeite) {
          <p-paginator
            [rows]="result.proSeite"
            [totalRecords]="result.total"
            [first]="(result.seite - 1) * result.proSeite"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[]"
          />
        }
      }
    }
  </div>

</div>
